import {
  Button,
  Card,
  Input,
  List,
  message,
  Modal,
  Popconfirm,
  Result,
  Select,
  Space,
} from "antd";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Router from "../..";
import { useUserStore } from "../../../stores/userStore";
import { REGEX } from "../../utils/Regex";

export const MembersManagement = () => {
  const history = useHistory();
  const { userInfo } = useUserStore();
  const [invitedEmail, setInvitedEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [invitedList, setInvitedList] = useState([]);
  const [memberList, setMemberList] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const [newGrade, setNewGrade] = useState("");

  const getInvitedMembers = async () => {
    const res = await Router.Api.getInvitedMembers();
    const list = res?.result ?? [];
    setInvitedList(list);
  };

  const getMembers = async () => {
    const res = await Router.Api.getMembers();
    const list = res?.result ?? [];
    setMemberList(list);
  };

  useEffect(() => {
    if (userInfo?.type_info?.company_id) {
      getInvitedMembers();
      getMembers();
    }
  }, [userInfo]);

  const onChangeInvited = (e) => {
    setInvitedEmail(e.target.value);
    setEmailError("");
  };

  const handleInvite = async () => {
    if (!invitedEmail) {
      setEmailError("이메일을 입력해주세요");
      return;
    }
    if (!REGEX.email.test(invitedEmail)) {
      setEmailError("올바른 이메일 형식을 입력해주세요");
      return;
    }

    setEmailError("");

    const res = await Router.Api.inviteMember(invitedEmail);
    if (res) {
      setInvitedEmail("");
      getInvitedMembers();
      getMembers();
    }
  };

  const handleCancelInvite = async (id) => {
    if (!id) return;
    const res = await Router.Api.cancelInvitedMembers(id);
    if (res) {
      getInvitedMembers();
    }
  };

  const showModal = (member) => {
    setSelectedMember(member);
    setNewGrade(member.grade);
    setOpen(true);
  };

  const handleGradeChange = async (userId, grade) => {
    let payload;

    if (userId && grade === "delete") {
      payload = { user_id: userId, grade };
    } else if (selectedMember) {
      payload = { user_id: selectedMember.id, grade: newGrade };
    } else {
      return;
    }

    const res = await Router.Api.updateMemberGrade(payload);

    if (res) {
      setOpen(false);
      getMembers();

      if (grade === "delete") {
        message.success("멤버가 삭제되었습니다.");
      } else {
        message.success("멤버 권한이 변경되었습니다.");
      }
    } else {
      if (grade === "delete") {
        message.error("멤버 삭제에 실패했습니다.");
      } else {
        message.error("멤버 권한 변경에 실패했습니다.");
      }
    }
  };

  const handleCancel = () => {
    setOpen(false);
  };

  if (!userInfo?.type_info) {
    return (
      <div>
        <Result
          title="브랜드 가입 또는 생성이 필요합니다"
          subTitle="멤버를 관리하려면 먼저 브랜드에 가입하거나 생성해주세요."
          extra={
            <Button
              type="primary"
              onClick={() => history.push("/workspace/info")}
            >
              워크스페이스로 이동하기
            </Button>
          }
        />
      </div>
    );
  }

  return (
    <div>
      <h2 className="md:text-4xl text-3xl font-bold">멤버 관리</h2>
      <div className="flex flex-col lg:flex-row lg:gap-5">
        {/* 왼쪽 컬럼 (데스크탑) / 전체 (모바일/패드) */}
        <div className="w-full max-w-[600px]">
          {/* 멤버 목록 */}
          <Card
            title="멤버 목록"
            className="w-full border border-[#d9d9d9] rounded-[10px] bg-white shadow-[0_2px_6px_rgba(0,0,0,0.1)] mb-[30px]"
          >
            {/* 가입된 멤버 목록 */}
            <div>
              {memberList.length > 0 ? (
                <List
                  dataSource={memberList}
                  renderItem={(item) => {
                    const currentUser = memberList.find(
                      (member) => member.email === userInfo?.user_info?.email
                    );
                    const isCurrentUserMaster = currentUser?.grade === "master";
                    const isOtherUser =
                      item.email !== userInfo?.user_info?.email;
                    const showButton = isCurrentUserMaster && isOtherUser;

                    return (
                      <List.Item
                        className="text-lg md:text-xl"
                        actions={
                          showButton
                            ? [
                                <Button
                                  type="link"
                                  onClick={() => showModal(item)}
                                  className="text-lg md:text-xl"
                                >
                                  권한 변경
                                </Button>,
                                <Popconfirm
                                  title="멤버에서 제외하시겠습니까?"
                                  onConfirm={() =>
                                    handleGradeChange(item.id, "delete")
                                  }
                                  okText="예"
                                  cancelText="아니오"
                                >
                                  <Button
                                    type="link"
                                    danger
                                    className="text-lg md:text-xl"
                                  >
                                    삭제
                                  </Button>
                                </Popconfirm>,
                              ]
                            : []
                        }
                      >
                        <List.Item.Meta
                          title={
                            <div className="flex items-center justify-start">
                              <div className="text-xl md:text-2xl font-medium whitespace-nowrap">
                                {item.first_name + " " + item.last_name}
                              </div>
                              <div
                                className={`px-2 md:px-3 py-1 rounded text-lg md:text-xl ml-2 text-center font-[500] ${
                                  item.grade === "master"
                                    ? "bg-[#E6F7ED] text-[#52C41A]"
                                    : item.grade === "editor"
                                    ? "bg-[#E6F4FF] text-[#1890FF]"
                                    : "bg-[#FFF7E6] text-[#FAAD14]"
                                }`}
                              >
                                {item.grade}
                              </div>
                            </div>
                          }
                          description={
                            <div className="flex justify-between items-center text-lg md:text-xl">
                              <span>{item.email}</span>
                            </div>
                          }
                        />
                      </List.Item>
                    );
                  }}
                />
              ) : (
                <div className="p-5 text-center text-[#999]">
                  가입된 멤버가 없습니다.
                </div>
              )}
            </div>
          </Card>

          {/* 초대 현황 */}
          {userInfo?.type_info?.grade === "master" ? (
            <>
              <Card
                title="초대 현황"
                className="w-full border border-[#d9d9d9] rounded-[10px] bg-white shadow-[0_2px_6px_rgba(0,0,0,0.1)] mb-[30px]"
              >
                <Space.Compact className="w-full">
                  <Input
                    placeholder="초대할 멤버의 이메일을 입력하세요"
                    value={invitedEmail}
                    onChange={onChangeInvited}
                    status={emailError ? "error" : ""}
                  />
                  <Button
                    type="primary"
                    onClick={handleInvite}
                    className="!bg-[#171717] border-[#171717]"
                  >
                    초대하기
                  </Button>
                </Space.Compact>
                {emailError && (
                  <div className="text-[#ff4d4f] mt-1 text-xl">
                    {emailError}
                  </div>
                )}

                {/* 초대한 멤버 목록 */}
                <div className="mt-5">
                  <p className="m-0 mb-4 text-[15px] font-semibold">
                    초대한 멤버 목록
                  </p>
                  {invitedList.length > 0 ? (
                    <List
                      dataSource={invitedList}
                      renderItem={(item) => (
                        <List.Item
                          actions={[
                            <Popconfirm
                              title="초대를 취소하시겠습니까?"
                              onConfirm={() => handleCancelInvite(item.id)}
                              okText="예"
                              cancelText="아니오"
                            >
                              {userInfo?.type_info?.grade === "master" && (
                                <Button type="link" danger>
                                  취소
                                </Button>
                              )}
                            </Popconfirm>,
                          ]}
                        >
                          <List.Item.Meta
                            title={item.user_email}
                            description={`초대일: ${
                              item.created_at.split(" ")[0]
                            }`}
                          />
                        </List.Item>
                      )}
                    />
                  ) : (
                    <div className="p-5 text-center text-[#999]">
                      초대한 멤버가 없습니다.
                    </div>
                  )}
                </div>
              </Card>
            </>
          ) : (
            ""
          )}

          <Modal
            open={open}
            title="멤버 권한 변경"
            onOk={handleGradeChange}
            onCancel={handleCancel}
            okText="변경"
            cancelText="취소"
            centered
            footer={(_, { OkBtn, CancelBtn }) => (
              <>
                <CancelBtn />
                <OkBtn />
              </>
            )}
          >
            {selectedMember && (
              <div>
                <p>
                  <strong>
                    {selectedMember.first_name + " " + selectedMember.last_name}
                    {`(${selectedMember.email})`}
                  </strong>
                  의 권한을 변경합니다.
                </p>
                <Select
                  value={newGrade}
                  onChange={setNewGrade}
                  className="w-full mt-2.5"
                  options={[
                    { value: "master", label: "Master" },
                    { value: "editor", label: "Editor" },
                    { value: "viewer", label: "Viewer" },
                  ]}
                />
              </div>
            )}
          </Modal>
        </div>
      </div>
    </div>
  );
};
